import "./runtime"

import "./shared/shoelace.js"

import Alpine from "alpinejs"
window.Alpine = Alpine

import {Application} from "stimulus"
import whatInput from "what-input"
import articles_controller from "./wellness/controllers/articles_controller"
import auth_controller from "./wellness/controllers/auth_controller"
import body_controller from "./wellness/controllers/body_controller"
import branding_controller from "./wellness/controllers/branding_controller"
import cta_controller from "./wellness/controllers/cta_controller"
import cta_logo_controller from "./wellness/controllers/cta_logo_controller"
import footer_controller from "./wellness/controllers/footer_controller"
import full_color_controller from "./wellness/controllers/full-color_controller"
import pagination_controller from "./wellness/controllers/pagination_controller"
import popular_controller from "./wellness/controllers/popular_controller"
import reward_form_controller from "./wellness/controllers/reward_form_controller"
import reward_quiz_controller from "./wellness/controllers/reward-quiz_controller"
import search_controller from "./wellness/controllers/search_controller"
import sidebar_controller from "./wellness/controllers/sidebar_controller"
import social_controller from "./wellness/controllers/social_controller"
import sticky_header_controller from "./wellness/controllers/sticky-header_controller"
import svg_fetch_controller from "./wellness/controllers/svg_fetch_controller"
import toggle_controller from "./wellness/controllers/toggle_controller"
import truncate_controller from "./wellness/controllers/truncate_controller"
import nav_controller from "./wellness/controllers/nav_controller"
import step_navigator_controller from "./wellness/controllers/step_navigator_controller"
import fwa_chart_controller from "./wellness/controllers/fwa_chart_controller"
import fwa_goal_controller from "./wellness/controllers/fwa_goal_controller"
import fwa_goal_list_controller from "./wellness/controllers/fwa_goal_list_controller"
import fwa_modal_controller from "./wellness/controllers/fwa_modal_controller"
import fwa_score_tooltip_controller from "./wellness/controllers/fwa_score_tooltip_controller"
import fwa_vocab_modal_controller from "./wellness/controllers/fwa_vocab_modal_controller"
import fwa_retake_modal_controller from "./wellness/controllers/fwa_retake_modal_controller"
import fwa_debug_profile_controller from "./wellness/controllers/fwa_debug_profile_controller"
import fwa_download_controller from "./wellness/controllers/fwa_download_controller"
import savings_milestone_controller from "./wellness/controllers/savings_milestone_controller"
import "./wellness/components/bz-fwa.js"

const application = Application.start()
application.register("articles", articles_controller)
application.register("auth", auth_controller)
application.register("body", body_controller)
application.register("branding", branding_controller)
application.register("cta", cta_controller)
application.register("cta-logo", cta_logo_controller)
application.register("footer", footer_controller)
application.register("full-color", full_color_controller)
application.register("pagination", pagination_controller)
application.register("popular", popular_controller)
application.register("reward-form", reward_form_controller)
application.register("reward-quiz", reward_quiz_controller)
application.register("sidebar", sidebar_controller)
application.register("social", social_controller)
application.register("search", search_controller)
application.register("sticky-header", sticky_header_controller)
application.register("svg-fetch", svg_fetch_controller)
application.register("toggle", toggle_controller)
application.register("truncate", truncate_controller)
application.register("nav", nav_controller)
application.register("step-navigator", step_navigator_controller)
application.register("fwa-chart", fwa_chart_controller)
application.register("fwa-goal", fwa_goal_controller)
application.register("fwa-goal-list", fwa_goal_list_controller)
application.register("fwa-modal", fwa_modal_controller)
application.register("fwa-score-tooltip", fwa_score_tooltip_controller)
application.register("fwa-vocab-modal", fwa_vocab_modal_controller)
application.register("fwa-retake-modal", fwa_retake_modal_controller)
application.register("fwa-debug-profile", fwa_debug_profile_controller)
application.register("fwa-download", fwa_download_controller)
application.register("savings-milestone", savings_milestone_controller)

Alpine.start()
